import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
 
      gcTime: 10 * 60 * 1000,
 
      retry: (failureCount, error) => {

        if (failureCount >= 3) return false;

        if (error instanceof Error && error.message.includes('Error del servidor: 4')) {
          return false;
        }
        
        return true;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
})

export default queryClient
